var _path, _circle, _line, _circle2, _path2, _circle3, _circle4, _circle5, _line2, _line3, _line4, _line5, _line6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRbac(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 8 L48 18 V34 L32 56 L16 34 V18 Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 12
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40.5,
    y1: 40.5,
    x2: 56,
    y2: 56
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 28,
    r: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 40 Q32 34 40 40 Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 12,
    r: 5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 32,
    r: 5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 52,
    r: 5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 17,
    x2: 8,
    y2: 24
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 24,
    x2: 16,
    y2: 24
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 32,
    x2: 16,
    y2: 32
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 47,
    x2: 8,
    y2: 40
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 40,
    x2: 16,
    y2: 40
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRbac);
export default __webpack_public_path__ + "static/media/rbac.cd2e078e1912599819ac116a6b5913cf.svg";
export { ForwardRef as ReactComponent };